import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import HouseInsert from '@/components/HouseInsert'
import HouseSearch from '@/components/HouseSearch'
import HouseView from '@/components/HouseView'
// import Home from "../components/Home";
// import Product from "../components/Product";

//解决vue-router 3.0以上 重复路由报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
	  {
		  path:'/',	//首页
		  component: Index
	  },
	  {
		  path:'/HouseView',
		  component: HouseView
	  },
	  {
		  path:'/HouseInsert',
		  component: HouseInsert
	  },
	  {
		  path:'/HouseSearch',
		  component: HouseSearch
	  }
  ]
})
